export const siteSettings = {
  name: "Exchange Worldwide",
  link: "https://exchangeworldwide.live",
  email: "support@exchangeworldwide.live",
  appLink: "https://app.exchangeworldwide.live",
};
